import React from 'react';
import { IconProps } from '@chakra-ui/react';

/**
 * A wrapper component to standardize icon sizes across the application
 */
interface IconWrapperProps {
  icon: React.ElementType;
  size?: string | number;
  props?: IconProps;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ 
  icon: Icon, 
  size = '2.0em',
  props
}) => {
  return <Icon fontSize={size} {...props} />;
};

export default IconWrapper;